import Vue from 'vue'
import App from './App.vue'
import router from "./router/";
import components from "./components";
import storageCleanup from "./mixins/storageCleanup";

Vue.config.productionTip = false;
Vue.config.filenameHashing = false;
Vue.mixin(storageCleanup);

new Vue({
	router,
	components,
	render: h => h(App),
}).$mount('#app')
